module.exports = __webpack_public_path__ + "static/lord-logo-e08d3c3b57daa237287173d777904d74.svg";